<template>
    <m-main-layout>
        <el-button size="small" type="primary" slot="right-btn" @click="$router.push({path:'/bids/'+type+'/list'})">返回列表
        </el-button>
        <div class="page-content-main">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="formData.title" maxlength="100" show-word-limit style="width: 500px;"></el-input>
                </el-form-item>
                <el-form-item label="标题样式" prop="title_style">
                    <one-checkbox v-model="formData.title_style.b">粗体</one-checkbox>
                    <one-checkbox v-model="formData.title_style.i">斜体</one-checkbox>
                    <one-checkbox v-model="formData.title_style.u">删除线</one-checkbox>
                </el-form-item>
                <el-form-item label="标题颜色" prop="title_style">
                    <color-select v-model="formData.title_style.c"></color-select>
                </el-form-item>
                <el-form-item label="关键词" prop="title_style">
                    <el-tag
                        :key="tag"
                        v-for="tag in formData.tags"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)" class="margin-right">
                        {{tag}}
                    </el-tag>
                    <el-input
                        class="input-new-tag"
                        v-if="inputVisible"
                        v-model="inputValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm"
                        style="width: 100px;"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加关键词</el-button>
                </el-form-item>
                <el-form-item label="来源" prop="source">
                    <el-input v-model="formData.source" maxlength="100" show-word-limit style="width: 500px;"></el-input>
                </el-form-item>
                <el-form-item label="外链" prop="out_url">
                    <el-input v-model="formData.out_url" maxlength="100" show-word-limit style="width: 500px;"></el-input>
                </el-form-item>
                <el-form-item label="作者" prop="author">
                    <el-input v-model="formData.author" maxlength="100" show-word-limit style="width: 500px;"></el-input>
                </el-form-item>
<!--                <el-form-item label="查看权限" prop="user_vip_type">-->
<!--                    <el-radio-group v-model="formData.user_vip_type">-->
<!--                        <el-radio label="free">游客</el-radio>-->
<!--                        <el-radio label="register">注册会员</el-radio>-->
<!--                        <el-radio label="vip">VIP</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="内容" prop="content">-->
<!--                    <editor v-model="formData.content"/>-->
<!--                </el-form-item>-->
                <el-form-item label="内容" prop="content" class="no-line-height">
                    <vue-ueditor-wrap v-model="formData.content" :config="config" :editor-id="'editorId'"></vue-ueditor-wrap>
                </el-form-item>
                <el-form-item label="是否可用" prop="state">
                    <el-switch
                        v-model="formData.state"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
            type:'',
            inputVisible: false,
            inputValue: '',
            formData: {
                id:'',
                title: '',
                title_style: {b:0,i:0,u:0,c:''},
                content: '',
                state: 1,
                user_vip_type: 'free',
                out_url:'',
                industry_type_id:'',
                province_code:'',
                province_name:'',
                tags:[],
                source:'',
                author:''
            },
            typeList: [],
            rules: {
                title: [{required: true, message: '标题必填'}],
                content: [{required: true, message: '内容必填'}],
            },
            routerData:null,
            url:'',
            config: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled:false,
                // 初始容器高度
                initialFrameHeight: 240,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                // serverUrl: this.$config.editUrl+`/UEditor/php/controller.php`,
                serverUrl: this.$config.editUrl,
                // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                UEDITOR_HOME_URL: '/ueditor/'
            }
        };
    },
    created() {
        this.formData.id  = this.$route.query.id ? this.$route.query.id :'';

        let _config = window.config.paths();
        let _path = this.$route.path.replace('/edit','');

        this.params = _config[_path];

        this.routerData = this.params.routerData ? this.params.routerData : {};
    },
    mounted() {
        if(this.formData.id) {
            this.url = this.params.apiUrl+'/edit';
            this.getDetail();
        }else{
            this.url = this.params.apiUrl+'/add';
        }
    },
    methods: {
        submitForm(formName) {
            let _this = this;
            console.log(this.formData);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    _this.$http.httpPost({
                        url: _this.url,
                        datas: {...this.formData,...this.routerData},
                        success: (res) => {
                            _this.$router.back();
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        getDetail(){
            let _this = this;
            _this.$http.httpPost({
                url: this.params.apiUrl+'/detail',
                datas: {id:this.formData.id},
                success: (res) => {
                    _this.formData = res;
                }
            });
        },

        handleClose(tag) {
            this.formData.tags.splice(this.formData.tags.indexOf(tag), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.formData.tags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        }
    }
}
</script>
